import { finalize, subscribeOn, tap } from 'rxjs/operators';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import {
  timeout,
  catchError,
  retry,
  delay,
  mergeMap,
  retryWhen,
} from 'rxjs/operators';
import { EMPTY, Observable, throwError, of, observable } from 'rxjs';



const getErrorMessage = (maxRetry: number) =>
  'Foram feitas ' + maxRetry + ' tentativas de check-in, sem sucesso';
const MaximoTentativas = 5;
const tempoEntreTentativas = 2000;



export function retryHttp(
      delayMs: number,
      maxRetry = MaximoTentativas,
      backoffms = tempoEntreTentativas
    ) {
      let retries = maxRetry;
      return (src: Observable<any>) =>
        src.pipe(
          retryWhen((errors: Observable<any>) =>
            errors.pipe(

              mergeMap((error) => {
                // tslint:disable-next-line: max-line-length
                if (error.message === 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/userApp/create: 0 Unknown Error'){
               //     console.log(error);
                  if (retries-- > 0) {
                    const backofftime = delayMs + (maxRetry - retries) * backoffms;
                    return of(error).pipe(delay(backofftime));
                  }

                }
                // tslint:disable-next-line: max-line-length
                if (error.message === 'Http failure response for https://*.api.alleshub.com.br/api_allescorp/userApp/create: 0 Unknown Error'){
                  return throwError(getErrorMessage(maxRetry));
              }
                 else{
                   return throwError(error);
                 }

              })
            )
          )
        );
    }



export function N2(n, multiplier = null) {
  if (isNaN(parseFloat(n))) {
    return 0;
  }
  if (multiplier === null) {
    multiplier = 100;
  } else {
    multiplier = Math.pow(10, multiplier);
  }
  return Math.round(n * multiplier) / multiplier;
}

export function onlyN(n) {
  return n.toString().replace(/\D/g, '');
}

export function wCard(n) {
  if (!n) {
    return n;
  }
  return n.toString().replace(/ /g, '%');
}

export function objectGet(obj, path) {
  const split = path.split('.');
  obj = obj.getRawValue ? obj.getRawValue() : obj;
  for (const i in split) {
    if (obj[split[i]] === null || obj[split[i]] === undefined) {
      return null;
    } else {
      obj = obj[split[i]];
    }
  }
  return obj;
}

export function btnLoading($event) {
  if (!$event) {
    return tap(() => {});
  }
  const element = $event.currentTarget || $event;
  if (!element) {
    return;
  }
  element.disabled = true;
  return finalize(() => {
    element.disabled = false;
  });
}

export function mustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // return if another validator has already found an error on the matchingControl
      return;
    }

    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

export function validarCpf(controlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    if (control.value) {
      if (validaCpf(control.value)) {
        return;
      } else {
        control.setErrors({ cpfInvalido: true });
      }
    }
  };
}

export function validaCpf(cpf) {
  let add = null;
  let rev = null;
  let i = null;
  if (cpf === '') {
    return false;
  }
  // Elimina CPFs invalidos conhecidos
  if (
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }
  // Valida 1o digito
  add = 0;
  for (i = 0; i < 9; i++) {
    // tslint:disable-next-line: radix
    add += parseInt(cpf.charAt(i)) * (10 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  // tslint:disable-next-line: radix
  if (rev !== parseInt(cpf.charAt(9))) {
    return false;
  }
  // Valida 2o digito
  add = 0;
  for (i = 0; i < 10; i++) {
    // tslint:disable-next-line: radix
    add += parseInt(cpf.charAt(i)) * (11 - i);
  }
  rev = 11 - (add % 11);
  if (rev === 10 || rev === 11) {
    rev = 0;
  }
  // tslint:disable-next-line: radix
  if (rev !== parseInt(cpf.charAt(10))) {
    return false;
  }
  return true;
}
export function validaCelular(telefone) {
  // tslint:disable-next-line: one-variable-per-declaration
  const stringFone = telefone.toString(),
    toConcat = stringFone + '';
  const checkIndex = toConcat.charAt(2);
  const checkZero = toConcat.charAt(1);
  if (toConcat.length !== 11) {
    return false;
  }
  if (checkIndex !== '9') {
    return false;
  } else {
    return true;
  }
}
export function validarCelular(controlName: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    if (control.value) {
      if (validaCelular(control.value)) {
        return;
      } else {
        control.setErrors({ celInvalido: true });
      }
    }
  };
}

export function arrayMove(arr, oldIndex, newIndex) {
  if (newIndex >= arr.length) {
    let k = newIndex - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
}

// Distância em metros de duas latLng
export function distanceLinear(lat1, lng1, lat2, lng2): number {
  const rad = (x) => (x * Math.PI) / 180;
  const R = 6378137; // Earth’s radius in meter
  const dLat = rad(lat2 - lat1);
  const dLong = rad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(rad(lat1)) *
      Math.cos(rad(lat2)) *
      Math.sin(dLong / 2) *
      Math.sin(dLong / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return N2(d); // returns the distance in meter
}
